import * as React from 'react';
import cx from 'classnames';

type FullPageSlideProps = {
    children?: React.ReactNode;
    extraClass?: string;
};

const FullPageSlide: React.FC<FullPageSlideProps> = ({ children, extraClass }) => {
    if (!children) {
        return null;
    }

    const className = cx({
        'full-page-slide': true,
        [extraClass as string]: extraClass,
    });

    return <div className={className}>{children}</div>;
};

export default FullPageSlide;
